var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 359.14 359.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #0f223c;\n      }\n\n      .cls-3 {\n        fill: #ffd11a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 359.14,
    height: 359.14,
    rx: 120,
    ry: 120
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.92,58.18c-5.06-1.06-10.33-1.6-15.71-1.6s-10.73.56-15.86,1.64v-.05c0-8.71,7.07-15.77,15.8-15.77s15.77,7.07,15.77,15.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.44,127.07h-1.98c-4.59-32.69-29.5-58.93-61.54-65.5-5.06-1.06-10.33-1.6-15.71-1.6s-10.73.56-15.86,1.64c-31.93,6.59-56.79,32.83-61.36,65.45h-2c-28.13,0-51.14,23.02-51.14,51.14v19.4c0,3.6,2.95,6.57,6.55,6.57h19.98v-.4c0-22.41,18.18-40.59,40.59-40.59s40.59,18.18,40.59,40.59v.4h45.68v-.4c0-22.41,18.18-40.59,40.59-40.59s40.59,18.18,40.59,40.59v.4h19.62c3.6,0,6.57-2.97,6.57-6.57v-19.4c0-28.13-23.02-51.14-51.17-51.14ZM127.03,127.07c5.06-24.73,26.98-43.4,53.19-43.4s48.13,18.68,53.19,43.4h-106.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.12,203.78c0,.13,0,.26-.01.39-.2,12.07-10.04,21.77-22.15,21.77s-21.94-9.71-22.14-21.77c-.01-.13-.01-.26-.01-.39,0-12.23,9.92-22.16,22.15-22.16s22.16,9.93,22.16,22.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M265.99,203.78c0,.13,0,.26-.01.39-.2,12.07-10.04,21.77-22.15,21.77s-21.94-9.71-22.14-21.77c-.01-.13-.01-.26-.01-.39,0-12.23,9.92-22.16,22.15-22.16s22.16,9.93,22.16,22.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.22,307.84c-31.4,0-59.58-18.68-71.81-47.6-2.55-6.03.27-12.98,6.3-15.53,6.03-2.55,12.98.27,15.53,6.3,8.51,20.13,28.13,33.13,49.98,33.13s41.28-12.89,49.86-32.83c2.59-6.01,9.56-8.79,15.57-6.21,6.01,2.59,8.79,9.56,6.21,15.57-12.33,28.65-40.44,47.17-71.63,47.17Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 194.44,
    y: 102.06,
    width: 12.41,
    height: 35.15,
    rx: 6.21,
    ry: 6.21
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon);
export default __webpack_public_path__ + "static/media/logoicon.5498e43c3932a28965ce9dc3bb8d19fd.svg";
export { ForwardRef as ReactComponent };